import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "price"
}
const _hoisted_6 = { class: "price" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["route", [_ctx.direction === _ctx.DirectionEnum.Outward ? 'outward': 'return', _ctx.bookingSection.departureDate > _ctx.today() ? 'disabled' : '']])
  }, [
    _createElementVNode("header", null, [
      _createVNode(_component_BaseSvg, {
        icon: _ctx.bookingSection.icon
      }, null, 8, ["icon"]),
      (_ctx.direction === _ctx.DirectionEnum.Outward)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.$t("departure.outward")), 1))
        : (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.$t("departure.return")), 1))
    ]),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, _toDisplayString(_ctx.bookingSection.routeText), 1),
      (_ctx.bookingSection.departureDate)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.EEE_dd_MMM_YYYY(_ctx.bookingSection.departureDate)) + " ", 1),
            (_ctx.bookingSection.arrivalDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "| " + _toDisplayString(_ctx.HHmm(_ctx.bookingSection.departureDate)) + " - " + _toDisplayString(_ctx.HHmm(_ctx.bookingSection.arrivalDate)), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingSection.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "price",
          key: index
        }, [
          _createElementVNode("span", null, _toDisplayString(item.text) + " " + _toDisplayString(item.amount), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(item.price.toFixed(2)), 1)
        ]))
      }), 128)),
      (_ctx.bookingSection.discount)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("basket.discount")), 1),
            _createElementVNode("span", null, "- " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.bookingSection.discount.toFixed(2)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`basket.${_ctx.DirectionEnum[_ctx.direction]}.price`)), 1),
        (_ctx.bookingSection.price > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.bookingSection.price.toFixed(2)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
      ])
    ])
  ], 2))
}